(function () {
  const Core = window.RB.Core;

  const OTHER_FRIENDLY_UNIT_OR_GEAR = {
    friendly: true, other: true,
    orSpecs: [
      { type: "unit", friendly: true, other: true },
      { type: "gear", friendly: true, other: true },
    ],
  };

  const EARLY_TURN = { k: "ownTurnsTaken", n: 2, cmp: "atMost" };

  const readySomethingElse = [{
    op: "may", prompt: "Ready something besides me that is exhausted?",
    then: [
      {
        op: "choose", bind: "_r", min: 1, max: 1,
        spec: { friendly: true, other: true, ready: false },
        prompt: "Ready which exhausted permanent?",
      },
      { op: "ready", to: "$_r" },
    ],
  }];

  const drawIfEarly = [{
    op: "if", cond: { k: "ownTurnsTaken", n: 2, cmp: "atMost" },
    then: [{ op: "draw", n: 1 }],
  }];

  const matchMightHere = function (on) {
    return {
      on: on, self: true, optional: false,
      condSpec: { k: "selfEmpowered" },
      label: on === "attack"
        ? "Empowered attacker: match a unit's Might here, then +1"
        : "Empowered defender: match a unit's Might here, then +1",
      targets: [{ bind: "m", spec: { type: "unit", here: true }, prompt: "Match which unit's Might?" }],
      program: [
        { op: "grant", to: "source", setMight: { mightOf: "$m" }, dur: "turn" },
        { op: "grant", to: "source", might: 1, dur: "turn" },
      ],
    };
  };

  const renektonWatch = function (on, label) {
    return {
      on: on, label: label,
      condSpec: {
        k: "and",
        conds: [{ k: "selfMightAtLeast", n: 10 }, { k: "not", cond: { k: "selfEmpowered" } }],
      },
      program: [{ op: "empowerSource" }],
    };
  };

  const relicBurn = function () {
    return [
      {
        op: "delayed", on: "burned", forPlayer: "controller", dur: "turn",
        condSpec: { k: "evType", type: "unit" },
        label: "burned a unit: give a friendly unit +Might equal to it",
        program: [
          {
            op: "choose", bind: "_bt", min: 1, max: 1,
            spec: { type: "unit", friendly: true },
            prompt: "Give which friendly unit +Might equal to the burned card's Might?",
          },
          { op: "grant", to: "$_bt", might: { mightOf: "$ev" }, dur: "turn" },
        ],
      },
      { op: "burn", n: 1 },
    ];
  };

  const tentacle = function () {
    return [{ op: "token", name: "Tentacle", n: 1, loc: "base" }];
  };

  window.RB.CardLib = window.RB.CardLib || {};
  window.RB.CardLib.ven = { OTHER_FRIENDLY_UNIT_OR_GEAR: OTHER_FRIENDLY_UNIT_OR_GEAR, EARLY_TURN: EARLY_TURN, readySomethingElse: readySomethingElse, drawIfEarly: drawIfEarly, matchMightHere: matchMightHere, renektonWatch: renektonWatch, relicBurn: relicBurn, tentacle: tentacle };
})();
